<template>
    <div class="home">
        <header :style="{background:bgc}">
         <img class="logo" @click="navigateTo('/')" src="@/assets/img/logo_m.jpg" alt />
         <div class="btn-con" @click="open">
           <i :class="[{draw:state.draw},{ closeDown: state.openflag } ]"></i>
           <i :class="[ {draw:state.draw},{ miss: state.openflag }]"></i>
           <i :class="[ {draw:state.draw},{ closeTop: state.openflag }]"></i>
         </div>
       </header>
        <ul class="nav" v-if="state.openflag">
        <!-- <video :loop="true" :autoplay="true" src="https://cdn-file.hyperos.mi.com/hyperos-file/system/point-boom_410x888.mp4" style="width: 100vw;"></video> -->
          <template v-for="(item,index) in state.menuList" :key="index">
            <li @click="handleTitle(index)"><span>{{ item.title }}</span><span :class="{ 'rotate': isRotated&&state.active===index }">+</span></li>
            <div v-show="item.collapsed&&state.active===index" id="myBox" :class="{ 'expanded':item.collapsed&&state.active===index }">
              <div class="menu_item" v-for="(item2,index2) in item.children" :key="index2" @click="handleMenu(index2,item)" :class="state.act===index2?'act':''">{{ item2.name }}</div>
            </div>
          </template>
       </ul>
   </div>
</template>
<script setup>
import {reactive,ref,watch} from 'vue'
const { t, locale } = useI18n()
const isRotated = ref(false);

const buildMenuList = () => [
  {
    title: t('mobile.menu.about'),
    collapsed: false,
    children:[
      {name: t('nav.enterprise'),path:'/aboutGBH/enterprise'},
      {name: t('nav.starTeam'),path:'/aboutGBH/star'},
      {name: t('nav.development'),path:'/aboutGBH/developed'},
      {name: t('nav.honor'),path:'/aboutGBH/honor'},
      {name: t('nav.contactInfo'),path:'/aboutGBH/contact'}
    ]
  },
  {
    title: t('mobile.menu.product'),
    collapsed: false,
    children:[
      {name: t('nav.ruichangtai'),path:'/product/proOne'},
      {name: t('nav.equipment'),path:'/product/proTwo'},
      {name: t('nav.research'),path:'/product/proThree'},
      {name: t('nav.reagent'),path:'/product/proFour'},
    ]
  },
  {
    title: t('mobile.menu.health'),
    collapsed: false,
    children:[
      {name: t('mobile.menu.health'),path:'/health'},
    ]
  },
  {
    title: t('mobile.menu.contact'),
    collapsed: false,
    children:[
      {name: t('nav.contactInfo'),path:'/contactUs/contactUs'},
      {name: t('nav.recruit'),path:'/contactUs/recruit'}
    ]
  },
  {
    title: t('mobile.menu.newsCenter'),
    collapsed: false,
    children:[
      {name: t('nav.newsCenter'),path:'/newsCenter'},
    ]
  },
]

const state = reactive({
  menuList: buildMenuList(),
  active:-1,
  act:-1,
  openflag: false,
  draw: true,
  bgc:''
})
const props = defineProps({
  bgc:{
    type:String,
    default:''
  }
})
function open() {
  state.openflag = !state.openflag;
  if(state.openflag){
    props.bgc='#fff'
  }else{
    props.bgc=''
    state.active=-1
  }
}
function handleTitle(index){
    state.active=index
    state.menuList[index].collapsed =!state.menuList[index].collapsed
    isRotated.value = !isRotated.value;
}
const emit = defineEmits(['clickMenu'])
function handleMenu(index2,item){
  state.act=index2
  emit('clickMenu',item,index2)
  state.openflag = false
}
watch(()=>state.active,(val)=>{
  if(val!==-1&&state.act!==-1){
    state.act=-1
  }
},{deep:true})
watch(locale, () => {
  state.menuList = buildMenuList()
})
</script>
<style lang="less">
// body,* {
//   margin: 0;
//   padding: 0;
// }
ul,li{
  list-style: none;
}
a{
  color:#666666;
  text-decoration: none;
  font-size: 16px;
}

header {
  width: 100%;
  box-sizing: border-box;
  height: 128px;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000009;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(20, 20, 20, 0.03);
  box-shadow: 5px 4px 10px 0px rgba(20,20,20,0.03);
  .logo{
    width: 170px;
    height: 76px;
  }
}
.btn-con {
  position: relative;
}
.btn-con i.draw {
  display: block;
  width: 40px;
  height: 3px;
  background: #009fe9;
  transition: 0.3s;
  z-index: 99;
}
.btn-con i.draw:first-of-type,
.btn-con i.draw:last-of-type {
  display: block;
  width: 40px;
  height: 3px;
  background: #009fe9;
  position: absolute;
  display: block;
  outline: none;
  top: -10px;
  transition: 0.3s;
}
.btn-con i.draw:last-of-type {
  top: 10px;
}

.btn-con .draw.miss {
  background: transparent;
}
.btn-con i.draw.closeDown {
  top: 0;
  transform: rotate(-45deg);
}
.btn-con i.draw.closeTop {
  top: 0;
  transform: rotate(45deg);
}
.nav{
  width:100%;
  height:0%;
  padding: 128px 30px 20px 30px;
  box-sizing: border-box;
  background-color: #fff;
   position: fixed;
   top:0;
   left:0;
   z-index: 9999;
   animation: heightAnimation .2s forwards;
   overflow-y: scroll;
   video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow-y: scroll;
}
      li{
      display: flex;
      justify-content: space-between;
      border-bottom: 0.05px solid #ddd;
      color: #9c9c9c;
      font-size: 28px;
      height: 110px;
      line-height: 110px;
      span:nth-child(2){
        font-size: 30px;
        transition: transform 0.2s ease-in-out;
      }
      .rotate {
        transform: rotate(160deg);
      }
    }
    p{
        .menu_item{
          margin-left: 46px;
        }
        .act{
          color: #00A0E9;
        }
    }
    .expanded {
        animation: liAnimation .2s ease-in-out forwards;
      }
}
@keyframes heightAnimation {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
@keyframes liAnimation {
  0% { height: 0; }
  100% { height: auto; }
}
</style>

